import React from 'react'
import classNames from 'classnames'
import { slugs } from '@/constants/slugs'
import { useToggle } from '@/hooks/useToggle'
import { useTranslate } from '@/utils/translate/translate-client'
import { BonusGiftCard } from '@/views/PreSales/PreSalesGiveawayView/components/TicketPack/BonusGiftCard'
import { BonusGiftModal } from '@/views/PreSales/PreSalesGiveawayView/components/TicketPack/BonusGiftModal'
import { GiveawayRefundCard } from '@/views/PreSales/PreSalesGiveawayView/components/TicketPack/GiveawayRefundCard'
import { PresaleChipSelectorCard } from '@/views/PreSales/PreSalesGiveawayView/components/TicketPack/PresaleChipSelectorCard'
import { useGiveawayContext } from '@/views/PreSales/PreSalesGiveawayView/context/GiveawayContext'
import { useBonusGift } from '@/views/PreSales/hooks/useBonusGift'

interface Props {
  className?: string
  mobileProductRef?: (node?: Element | null | undefined) => void
  ref?: React.Ref<HTMLDivElement>
}

const TicketPackSection = ({ className, mobileProductRef, ...rest }: Props) => {
  const { t } = useTranslate('tickets')

  const { tickets, entryVariantId, theatricalSlug, handleRefundInfoClick, projectName, giveawayData } =
    useGiveawayContext()
  const { bonusGift } = useBonusGift(theatricalSlug)
  const [isBonusPrizeModalOpen, setIsBonusPrizeModalOpen] = useToggle(false)

  if (!tickets || !entryVariantId) {
    return null
  }

  return (
    <>
      <div {...rest} className={classNames('w-full px-4 md:px-12', className)}>
        <div
          ref={mobileProductRef}
          className="mx-auto flex w-full max-w-[408px] flex-col space-y-6 py-16 md:top-0 lg:!sticky shortDesktop:!static shortDesktop:top-auto"
        >
          <div className="space-y-2">
            {!!bonusGift && (
              <BonusGiftCard
                bonusGift={bonusGift}
                onLearnMoreClick={() => {
                  setIsBonusPrizeModalOpen(true)
                }}
              />
            )}
            {theatricalSlug !== slugs.youngWashington && (
              <GiveawayRefundCard
                theatricalSlug={theatricalSlug}
                title={t('giveawayRefundGuarantee', 'Showtime Guarantee')}
                description={t(
                  'giveawayRefundGuaranteeDescriptionV3',
                  '{{projectName}} releases nationwide {{releaseDate}}; if no showtimes appear near you, you can get a full refund. ',
                  { projectName, releaseDate: giveawayData.releaseDate },
                )}
                onInfoClick={handleRefundInfoClick}
              />
            )}
          </div>
          <PresaleChipSelectorCard
            theatricalSlug={theatricalSlug}
            tickets={tickets}
            entriesProductId={entryVariantId}
          />
        </div>
      </div>

      {bonusGift && (
        <BonusGiftModal
          theatricalSlug={theatricalSlug}
          isOpen={isBonusPrizeModalOpen}
          onClose={() => {
            setIsBonusPrizeModalOpen(false)
          }}
          bonusGift={bonusGift}
          onCtaClick={() => {
            setIsBonusPrizeModalOpen(false)
          }}
        />
      )}
    </>
  )
}

export default TicketPackSection
